import { createStyles, makeStyles } from '@material-ui/styles';
import * as React from 'react';
import { FC } from 'react';
import { Slider, SliderState } from './Slider';
import SliderRail, { RailZone } from './SliderRail';
import Image from './Image';
import stylesheet, { secondaryColor } from 'src/constants/stylesheet';
import previousArrow from '../Assets/arrow_left.svg';
import nextArrow from '../Assets/arrow_right.svg';
import CurrentLegend from './Slider/CurrentLegend';
import * as classNames from 'classnames';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import { Responsive } from 'src/@context/Responsive';
import { Parallax } from 'react-scroll-parallax';
import { Link } from 'react-router-dom';
import { useApi } from 'src/@context/Api';

const sliderGutter = {
  Mobile: 40,
  Tablet: 50,
  Laptop: 100,
  Desktop: 100
};

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'relative',
      [mediaQueries.Mobile]: {
        height: `calc(100vh - ${spacing.headerHeight.Mobile}px)`
      },
    },
    slider: {
      width: '100%',
      [mediaQueries.Mobile]: {
        height: '100%'
      },
      [mediaQueries.AfterMobile]: {
        marginBottom: 25
      },
    },
    sliderContainer: {
      position: 'relative',
      width: '100%',

      overflow: 'hidden',
      [mediaQueries.Mobile]: {
        height: '100%'
      },
      [mediaQueries.AfterMobile]: {
        height: 538,
      },
    },
    imageContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
    mobileImageLink: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 1,
    },
    image: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      ...stylesheet.ObjectFitContain
    },
    sliderPrevious: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 25,
      height: 50,
      zIndex: 10,
      cursor: 'pointer',
      [mediaQueries.Mobile]: {
        display: 'none'
      },
      [mediaQueries.Tablet]: {
        left: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        left: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        left: spacing.Gutter.Desktop,
      }
    },
    sliderNext: {
      position: 'absolute',
      top: '50%',
      right: 100,
      transform: 'translateY(-50%)',
      width: 25,
      height: 50,
      zIndex: 10,
      cursor: 'pointer',
      [mediaQueries.Mobile]: {
        display: 'none'
      },
      [mediaQueries.Tablet]: {
        right: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        right: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        right: spacing.Gutter.Desktop,
      }
    },
    arrowSvg: {
      width: '100%',
    },
    legendsContainer: {
      position: 'absolute',
      bottom: 30,
      [mediaQueries.Mobile]: {
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '85%',
        bottom: 'auto'
      },
      [mediaQueries.Tablet]: {
        left: sliderGutter.Tablet,
        right: sliderGutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        left: sliderGutter.Laptop,
        right: sliderGutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        left: sliderGutter.Desktop,
        right: sliderGutter.Desktop,
      }
    },
    legends: {
      width: '100%',
      maxWidth: 350,
      marginLeft: 'auto',
      [mediaQueries.Mobile]: {
        margin: '0 auto '
      },
      [mediaQueries.AfterMobile]: {
        position: 'absolute',
        bottom: 0,
        right: 0,
      }
    },
    legend: {
      position: 'relative',
    },
    legendTitle: {
      ...stylesheet.MediumText,
      color: 'white',
      fontSize: '1.3rem',

      [mediaQueries.Mobile]: {
        fontSize: '1.1rem',
        // lineHeight: 1
      }
    },
    legendInfo: {
      ...stylesheet.RegulerText,
      color: 'white',
      fontSize: '1.3rem',

      [mediaQueries.Mobile]: {
        fontSize: '1.1rem',
        // lineHeight: 1
      },
    },
    legendLink: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
    dots: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      [mediaQueries.Mobile]: {
        width: 'auto',
        position: 'fixed',
        left: '100%',
        top: '50%',
        transform: 'translateY(-50%)',

        display: 'flex',
        flexDirection: 'column',
      },
    },
    dot: {
      width: 6,
      height: 6,
      borderRadius: '100%',
      background: 'white',
      opacity: .5,
      transition: 'opacity .3s ease',
      [mediaQueries.Mobile]: {
        width: 10,
        height: 10,
        margin: '5px 0',
      },
      [mediaQueries.AfterMobile]: {
        width: 6,
        height: 6,
        margin: '0 5px',
      }
    },
    dotActive: {
      opacity: 1,
    },
    section: {},
    sectionTitle: {
      position: 'relative',
      maxWidth: spacing.websiteMaxWidth,
      margin: '0 auto',

      [mediaQueries.Tablet]: {
        padding: `0 ${spacing.Gutter.Tablet}px`
      },
      [mediaQueries.Laptop]: {
        padding: `0 ${spacing.Gutter.Laptop}px`
      },
      [mediaQueries.Desktop]: {
        padding: `0 ${spacing.Gutter.Desktop}px`
      },

      '& span': {
        padding: '0 5px',
        color: 'white',
        backgroundColor: secondaryColor
      }
    },
    borderBottom: {
      borderBottom: `1px solid ${secondaryColor}`,
    },
    borderTop: {
      borderTop: `1px solid ${secondaryColor}`,
    },
    projectArticleInner: {
      maxWidth: spacing.websiteMaxWidth,
      margin: '0 auto',
      display: 'flex',
    },
    projectText: {
      position: 'relative',
      flex: `1 0 60%`,
      [mediaQueries.Tablet]: {
        padding: `47px ${spacing.Gutter.Tablet}px`
      },
      [mediaQueries.Laptop]: {
        padding: `47px 150px 47px ${spacing.Gutter.Laptop}px`
      },
      [mediaQueries.Desktop]: {
        padding: `47px 150px 47px ${spacing.Gutter.Desktop}px`
      }
    },
    projectTitle: {
      ...stylesheet.MainTitle,
      color: secondaryColor,
      marginBottom: 3
    },
    projectPlace: {
      ...stylesheet.SubTitle,
      color: secondaryColor,
      marginBottom: 3
    },
    projectInfo: {
      fontSize: '1.188rem',
    },
    projectImageContainer: {
      // flex: `1 0 ${1 / 3 * 100}%`,
      flex: `1 0 40%`,
      padding: '15px 0',
    },
    projectImage: {
      position: 'relative',
      height: 0,
      overflow: 'hidden',
      paddingBottom: '76.78%'
    },
    projectImageInner: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    },
    projectImageInnerHover: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      opacity: 0,
      pointerEvents: 'none',
      // transition: 'opacity .4s ease',

      '$projectImage:hover &': {
        opacity: 1,
        pomiterEvents: 'initial'
      }
    },
    projectLink: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },
    ImagePreview: {},
    parallexContainer: {
      position: 'relative',
      margin: '40px 0 20px 0',
      height: 410,
      overflow: 'hidden',
      // backgroundImage: (p: any) => `url(${p.ProjectSectionImage.Src}?width=2000)`
    },
    parallaxOuter: {
      position: 'absolute',
      top: '50%',
      left: 0,
      right: 0,
      height: '100vh',
      transform: 'translateY(-50%)'
    },
    parallaxInner: {
      height: '100%',

    },
    newsContent: {
      maxWidth: spacing.websiteMaxWidth,
      margin: '20px auto',
    },
    newsContentInner: {
      display: 'flex',
      [mediaQueries.Tablet]: {
        paddingLeft: spacing.Gutter.Tablet / 2,
        paddingRight: spacing.Gutter.Tablet / 2,
        paddingBottom: spacing.Gutter.Tablet
      },
      [mediaQueries.Laptop]: {
        paddingLeft: spacing.Gutter.Laptop / 2,
        paddingRight: spacing.Gutter.Laptop / 2,
        paddingBottom: spacing.Gutter.Laptop
      },
      [mediaQueries.Desktop]: {
        paddingLeft: spacing.Gutter.Desktop / 2,
        paddingRight: spacing.Gutter.Desktop / 2,
        paddingBottom: spacing.Gutter.Desktop
      }
    },
    news: {
      flex: `1 0 ${1 / 3 * 100}%`,
      [mediaQueries.Tablet]: {
        paddingLeft: spacing.Gutter.Tablet / 2,
        paddingRight: spacing.Gutter.Tablet / 2
      },
      [mediaQueries.Laptop]: {
        paddingLeft: spacing.Gutter.Laptop / 2,
        paddingRight: spacing.Gutter.Tablet / 2
      },
      [mediaQueries.Desktop]: {
        paddingLeft: spacing.Gutter.Desktop / 2,
        paddingRight: spacing.Gutter.Tablet / 2
      }
    },
    newsTitle: {},
    newsDate: {
      fontSize: '.88rem',
      marginBottom: 10
    },
    newsText: {
      fontSize: '1.25rem',
      marginBottom: 10
    },
    newsLink: {
      fontSize: '.88rem',
      textDecoration: 'underline',
    },
  }));
export type Home = HomeDto;
export const formatDate = (date: string) => {
  const dateObj = new Date(date);
  const day = dateObj.getDate();
  const month = dateObj.getMonth();
  const year = dateObj.getFullYear();
  return `${day}/${month}/${year}`
}

type Props = Home;

const Home: FC<Props> = ({ SliderProjects, HomeProjects, ProjectSectionImage, News }) => {
  const cls = useStyles({ ProjectSectionImage });
  const { app } = useApi();

  const isMobile = document.body.clientWidth <= 690; // 690 from responsive.ts

  const handleClick = (zone: RailZone, state: SliderState) => {
    const { goNext, goPrevious } = state;

    switch (zone) {
      case 'previous':
        goPrevious();
        break;
      case 'next':
        goNext();
        break;
    }
  }

  const images = SliderProjects && SliderProjects.map((s, i) =>
    <div
      key={i}
      className={cls.imageContainer}
    >
      {isMobile && <Link to={s.URL} className={cls.mobileImageLink} />}
      <Image
        className={cls.image}
        pictureRef={s.ImagePreview}
        sizes="100vw"
      />
    </div>
  );

  const legends = SliderProjects && SliderProjects.map((l, i) =>
    <div key={i} className={cls.legend}>
      <Link to={l.URL} className={cls.legendLink} />
      <div className={cls.legendTitle}>
        {`${l.Subtitle} ${l.Place ? ` / ${l.Place}` : null}`}
      </div>
      <div className={cls.legendInfo}>
        {l.Info}
      </div>
    </div>
  );

  const porjectsLink = app && app.Menus.find(m => m.type === 'Projects');

  return (
    <div className={cls.root}>
      {SliderProjects &&
        <div className={cls.slider}>
          <Slider
            width={100}
            nodes={images}
            delay={isMobile ? 2000 : 6000}
            loop={true}
          >
            <div
              className={cls.sliderContainer}
            >
              <Slider.Consumer>
                {(state: SliderState) => {
                  const click = (zone: RailZone) => handleClick(zone, state);
                  return (
                    <>
                      {images.length > 1 && <>
                        <a className={cls.sliderPrevious} onClick={state.goPrevious}>
                          <img src={previousArrow} className={cls.arrowSvg} alt='arrow facing left' />
                        </a>
                        <a className={cls.sliderNext} onClick={state.goNext}>
                          <img src={nextArrow} className={cls.arrowSvg} alt='arrow facing left' />
                        </a>
                      </>}
                      <SliderRail
                        click={click}
                      />
                      <div className={cls.legendsContainer}>
                        <div className={cls.legends}>
                          <CurrentLegend legends={legends} />
                        </div>
                        <div className={cls.dots}>
                          {SliderProjects.map((d, i) =>
                            <div key={i}
                              className={
                                classNames(cls.dot, i === (state.current % SliderProjects.length) && cls.dotActive)
                              }
                            />
                          )}
                        </div>
                      </div>
                    </>);
                }}
              </Slider.Consumer>
            </div>
          </Slider>
        </div>
      }
      <Responsive steps={['AfterMobile']}>
        <section className={cls.section}>
          <h4 className={cls.sectionTitle}>
            <span>EN COURS</span>
          </h4>
          {HomeProjects.map((h, i) =>
            <article
              key={i}
              className={classNames(cls.borderBottom, i === 0 && cls.borderTop)}
            >
              <div className={cls.projectArticleInner}>
                <div className={cls.projectText}>
                  <h2 className={cls.projectTitle}>{h.Subtitle}</h2>
                  <h3 className={cls.projectPlace}>{h.Place}</h3>
                  <div className={cls.projectInfo}>{h.Info}</div>
                  <Link to={h.URL} className={cls.projectLink} />
                </div>
                <div className={cls.projectImageContainer}>
                  <div className={cls.projectImage}>
                    <div className={cls.projectImageInner}>
                      <Image
                        pictureRef={h.ImagePreview}
                        sizes="100vw"
                        className={cls.image}
                      />
                    </div>
                    <div className={cls.projectImageInnerHover}>
                      <Image
                        pictureRef={h.HoverImagePreview}
                        sizes="100vw"
                        className={cls.image}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </article>
          )}
        </section>
        <section className={classNames(cls.section, cls.borderBottom)}>
          <h4 className={cls.sectionTitle}>
            {
              porjectsLink && <Link className={cls.legendLink} to={`/${porjectsLink.UID}`} />
            }
            <span>+ DE PROJECTS</span>
          </h4>
          <div className={cls.parallexContainer}>
            <Parallax
              y={[10, -10]}
              styleOuter={{ height: '100%', }}
              styleInner={{
                position: 'relative',
                height: '100vh',
              }}
            >
              <div
                // className={cls.test} 
                style={{
                  width: '100%',
                  height: '100%',
                  backgroundImage: `url(${ProjectSectionImage.Src}?width=2000)`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundAttachment: 'fixed',
                }}
              />
            </Parallax>
          </div>
        </section>

        <section className={cls.section}>
          <h4 className={cls.sectionTitle}>
            <span>ON EN PARLE</span>
          </h4>
          <div className={cls.newsContent}>
            <div className={cls.newsContentInner}>
              {News.map((n, i) =>
                <div
                  key={`news-${i}`}
                  className={cls.news}
                >
                  <div className={cls.newsDate}>{formatDate(n.Date)}</div>
                  <div className={cls.newsText}>{n.PreviewText}</div>
                  {n.ExternalLink.length > 0 &&
                    <a
                      href={n.ExternalLink}
                      className={cls.newsLink}
                      target="_blank"
                    >
                      En savoir plus
                    </a>
                  }
                  {n.ExternalLink.length <= 0 &&
                    <Link to={n.InternalLink} className={cls.newsLink}>En savoir plus</Link>
                  }
                </div>
              )}
            </div>
          </div>
        </section>
      </Responsive>
    </div>
  );
};

export default Home;


// WEBPACK FOOTER //
// ./src/Components/Home.tsx